import React, { useState } from "react";
import { LOCALE } from "../../properties/Locale";
import { useDispatch, useSelector } from "react-redux";
import { changePageTitle } from "../../common/actions/CommonActions";
import { VacancyRepository } from "../vacancy/VacancyRepository";
import { VacancyAppRepository } from "./VacancyAppRepository";
import CardBody from "../../common/components/Card/CardBody";
import {
  Button,
  Tooltip,
  Icon,
  Typography,
  TableHead,
  Table,
  TableRow,
  TableCell,
  TextField,
  IconButton,
  TableBody,
  Chip,
} from "@material-ui/core";
import { Link, Redirect } from "react-router-dom";
import CardHeader from "../../common/components/Card/CardHeader";
import Card from "../../common/components/Card/Card";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";
import moment from "moment";

export default function MyVacancyAppsComponent() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [data, setData] = useState({
    totalElements: 0,
    number: 0,
    content: [],
  });
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [orderBy, setOrderBy] = useState("dateCreated");
  const [orderDirection, setOrderDirection] = useState("DESC");
  const [filterBy, setFilterBy] = useState();
  const [filterValue, setFilterValue] = useState();
  const [filterData, setFilterData] = useState({ name: "" });
  const globalState = useSelector((state) => state);
  const [redirect, setRedirect] = React.useState();

  React.useEffect(() => {
    dispatch(changePageTitle(LOCALE.my_applications));
    loadData(page, size, orderBy, orderDirection);
  }, [dispatch]);

  const loadData = (page, size, orderBy, orderDirection) => {
    VacancyAppRepository.getAllByCurrentUser({
      page: page,
      size: size,
      orderBy: orderBy,
      orderDirection: orderDirection,
      filterBy: filterBy,
      filterValue: filterValue,
    })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {});
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setSize(parseInt(event.target.value, 10));
  };

  const handleFilterUserFieldChange = (name) => (event) => {
    setFilterData({ [name]: event.target.value });
    setFilterBy(name);
    setFilterValue(event.target.value);
  };
  const handleClickChangeOrderBy = (event) => {
    let orderValue = event.currentTarget.value;
    if (orderBy === orderValue) {
      if (orderDirection === "ASC") {
        setOrderDirection("DESC");
      } else {
        setOrderDirection("ASC");
      }
    } else {
      setOrderBy(orderValue);
      setOrderDirection("DESC");
    }
  };

  const openVacancy = (vacId, appId) => {
    setRedirect("/app/vacancy-application/" + vacId + "/" + appId);
  };

  return (
    <div>
      {redirect && <Redirect to={redirect} />}
      <Card>
        <CardHeader color="theme">
          <Typography>{LOCALE.my_applications}</Typography>
        </CardHeader>
        <CardBody>
          <Table aria-label="users table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.vacancy}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.created_at}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.submissionDate}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.status}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                  style={{
                    width: "100px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data?.content.map((vacancyApp, index) => (
                  <TableRow
                    style={index % 2 === 1 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell>{`${
                      vacancyApp.vacancy.name
                    } - ${LOCALE.getString(
                      vacancyApp?.vacancy?.vacancyType,
                    )}`}</TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.dateCreated &&
                        moment(vacancyApp.dateCreated).format(
                          "YYYY-MM-DD HH:mm:ss",
                        )}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.submissionDate &&
                        moment(vacancyApp.submissionDate).format(
                          "YYYY-MM-DD HH:mm:ss",
                        )}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.status && vacancyApp.status === "DRAFT" && (
                        <Chip
                          label={LOCALE.getString("DRAFT")}
                          style={{
                            color: "white",
                            backgroundColor: "orange",
                          }}
                        />
                      )}
                      {vacancyApp.status &&
                        vacancyApp.status === "SUBMITTED" && (
                          <Chip
                            label={LOCALE.getString("SUBMITTED")}
                            style={{
                              color: "white",
                              backgroundColor: "green",
                            }}
                          />
                        )}
                      {vacancyApp.status &&
                        vacancyApp.status === "ADDITIONAL_DATA_REQUIRED" && (
                          <>
                            <Chip
                              label={LOCALE.getString(
                                "ADDITIONAL_DATA_REQUIRED",
                              )}
                              style={{
                                color: "white",
                                backgroundColor: "orange",
                              }}
                            />
                            {vacancyApp?.additionalDataRequiredComment && (
                              <Tooltip
                                title={`Причина: ${vacancyApp?.additionalDataRequiredComment}`}
                                arrow
                                placement="top"
                              >
                                <IconButton size="small">
                                  <Icon>question_mark</Icon>
                                </IconButton>
                              </Tooltip>
                            )}
                          </>
                        )}
                      {vacancyApp.status &&
                        vacancyApp.status === "COMMISION_EVAL" && (
                          <Chip
                            label={LOCALE.getString("COMMISION_EVAL")}
                            style={{
                              color: "white",
                              backgroundColor: "green",
                            }}
                          />
                        )}
                      {vacancyApp.status &&
                        vacancyApp.status === "BRO_CSO_SCHOOL_EVAL" && (
                          <Chip
                            label={LOCALE.getString("BRO_CSO_SCHOOL_EVAL")}
                            style={{
                              color: "white",
                              backgroundColor: "green",
                            }}
                          />
                        )}
                      {vacancyApp.status &&
                        vacancyApp.status === "EVALUATED" && (
                          <Chip
                            label={LOCALE.getString("EVALUATED")}
                            style={{
                              color: "white",
                              backgroundColor: "green",
                            }}
                          />
                        )}
                      {vacancyApp.status &&
                        vacancyApp.status === "REJECTED" && (
                          <Chip
                            label={LOCALE.getString("REJECTED")}
                            style={{
                              color: "white",
                              backgroundColor: "red",
                            }}
                          />
                        )}
                      {vacancyApp.status &&
                        vacancyApp.status === "SUSPENDED" && (
                          <Chip
                            label={LOCALE.getString("SUSPENDED")}
                            style={{
                              color: "white",
                              backgroundColor: "red",
                            }}
                          />
                        )}
                    </TableCell>
                    <TableCell>
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        onClick={() =>
                          openVacancy(vacancyApp.vacancy.id, vacancyApp.id)
                        }
                      >
                        <Icon size={10}>edit</Icon> &nbsp;
                        {LOCALE.open}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
}
